import { render } from "./VisualizarContato.vue?vue&type=template&id=7efd0c4f&scoped=true"
import script from "./VisualizarContato.vue?vue&type=script&lang=js"
export * from "./VisualizarContato.vue?vue&type=script&lang=js"

import "./VisualizarContato.vue?vue&type=style&index=0&id=7efd0c4f&scoped=true&lang=css"

import exportComponent from "J:\\Centrion\\projetos\\apracam_ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7efd0c4f"]])

export default __exports__